// extracted by mini-css-extract-plugin
export var addButton = "_5a-d";
export var bullets = "_5a-e";
export var compact = "_5a-2";
export var container = "_5a-j";
export var extendedWarrantyModal = "_5a-f";
export var learn = "_5a-l";
export var learnMore = "_5a-g";
export var offeringOption = "_5a-3";
export var offeringPrice = "_5a-8";
export var offeringSubtitle = "_5a-7";
export var offeringTitle = "_5a-6";
export var offeringsContainer = "_5a-0";
export var pdpTilesBackground = "_5a-n";
export var plan = "_5a-m";
export var regular = "_5a-1";
export var remove = "_5a-k";
export var seeDetailsIcon = "_5a-i";
export var seeDetailsLink = "_5a-h";
export var selectedOption = "_5a-4";
export var shieldIcon = "_5a-b";
export var shieldIconCompact = "_5a-c";
export var subtitle = "_5a-a";
export var title = "_5a-9";
export var unselectedOption = "_5a-5";